export default __webpack_public_path__ + "static/media/technology.a23d977e.png";